<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button
        mat-icon-button
        class="noOutline"
        (click)="isExpanded = !isExpanded"
      >
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-3 d-print-none d-flex align-items-center">
          <span class="toolbar-title"
            >{{ documentType?.description }} Builder</span
          >
        </div>
        <div class="col-sm-12 col-md-9 pr-0">
          <div class="row full-width">
            <div class="col-12 col-md-3" *ngIf="documentType">
              <div class="type-header">
                <mat-form-field appearance="outline" class="with-closex">
                  <mat-label>Template Type</mat-label>
                  <input
                    type="text"
                    placeholder="Select Type"
                    matInput
                    name="typeCtrl"
                    [formControl]="typeCtrl"
                    [matAutocomplete]="autoType"
                    (keyup)="changedType()"
                    #triggerType="matAutocompleteTrigger"
                  />

                  <mat-icon
                    *ngIf="currentTemplateType"
                    class="red"
                    (click)="
                      clearTemplateTypes();
                      $event.stopPropagation();
                      triggerType.openPanel()
                    "
                    >close</mat-icon
                  >
                  <mat-autocomplete
                    #autoType="matAutocomplete"
                    #typeAutocomplete
                    [displayWith]="displayObject"
                    (optionSelected)="
                      selectedType($event); checkCreateEnabled()
                    "
                  >
                    <mat-option
                      *ngFor="let type of filteredTemplateTypes"
                      [value]="type"
                    >
                      {{ type.name }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-hint class="error" *ngIf="!currentTemplateType"
                    >You must choose a Type</mat-hint
                  >
                  <mat-hint *ngIf="currentTemplateType">
                    {{ currentTemplateType.description }}
                  </mat-hint>
                </mat-form-field>
              </div>
            </div>
            <div
              class="col-12 col-md-3"
              *ngIf="currentTemplateType?.allowMultipleVersions"
            >
              <div class="type-header">
                <mat-form-field
                  appearance="outline"
                  class="with-closex"
                  id="customNameCtrl"
                >
                  <mat-label>Custom Name</mat-label>
                  <input
                    type="text"
                    placeholder="Custom Name"
                    matInput
                    name="nameCtrl"
                    [formControl]="nameCtrl"
                    [matAutocomplete]="autoOther"
                    (keyup)="checkCreateEnabled()"
                  />

                  <mat-icon
                    *ngIf="nameCtrl.value"
                    class="red"
                    (click)="clearCustomFilter(); checkCreateEnabled()"
                    >close</mat-icon
                  >
                  <mat-autocomplete
                    #autoOther="matAutocomplete"
                    #otherAutocomplete
                    [displayWith]="displayObject"
                    (optionSelected)="checkCreateEnabled()"
                  >
                    <mat-option
                      *ngFor="let other of filteredOther"
                      [value]="other"
                      (onSelectionChange)="customNameSelected(other)"
                    >
                      {{ other.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
            <div
              class="col-12 col-md-3"
              *ngIf="currentTemplateType?.scheduleTypeID"
            >
              <div class="type-header">
                <mat-form-field
                  appearance="outline"
                  class="with-closex"
                  id="scheduleCtrl"
                >
                  <mat-label>Resource</mat-label>
                  <input
                    type="text"
                    placeholder="Select Resource"
                    matInput
                    name="scheduleCtrl"
                    [formControl]="scheduleCtrl"
                    [matAutocomplete]="autoSchedule"
                    (keyup)="changedSchedule()"
                    #triggerSchedule="matAutocompleteTrigger"
                  />

                  <mat-icon
                    *ngIf="currentSchedule"
                    class="red"
                    (click)="
                      clearSchedules();
                      $event.stopPropagation();
                      triggerSchedule.openPanel()
                    "
                    >close</mat-icon
                  >
                  <mat-autocomplete
                    #autoSchedule="matAutocomplete"
                    #scheduleAutocomplete
                    [displayWith]="displayObject"
                    (optionSelected)="
                      selectedSchedule($event); checkCreateEnabled()
                    "
                  >
                    <mat-option
                      [ngClass]="{ gray: schedule.objectInfo }"
                      *ngFor="let schedule of filteredSchedules"
                      [value]="schedule"
                    >
                      {{ schedule.name }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-hint class="error" *ngIf="!currentSchedule"
                    >You must select a Resource</mat-hint
                  >
                  <mat-hint *ngIf="currentSchedule">
                    {{ currentSchedule.description }}
                  </mat-hint>
                </mat-form-field>
              </div>
            </div>
            <div
              class="col-12 col-md-3"
              *ngIf="
                currentTemplateType?.resourceTypeID &&
                !this.currentTemplateType?.scheduleTypeID
              "
            >
              <div class="type-header">
                <mat-form-field
                  appearance="outline"
                  class="with-closex"
                  id="resourceCtrl"
                >
                  <mat-label>Resource</mat-label>
                  <input
                    type="text"
                    placeholder="Select Resource"
                    matInput
                    name="resourceCtrl"
                    [formControl]="resourceCtrl"
                    [matAutocomplete]="autoResource"
                    (keyup)="changedResource()"
                    #triggerResource="matAutocompleteTrigger"
                  />

                  <mat-icon
                    *ngIf="currentResource"
                    class="red"
                    (click)="
                      clearResources();
                      $event.stopPropagation();
                      triggerResource.openPanel()
                    "
                    >close</mat-icon
                  >
                  <mat-autocomplete
                    #autoResource="matAutocomplete"
                    #resourceAutocomplete
                    [displayWith]="displayObject"
                    (optionSelected)="
                      selectedResource($event); checkCreateEnabled()
                    "
                  >
                    <mat-option
                      *ngFor="let resource of filteredResources"
                      [value]="resource"
                    >
                      {{ resource.name }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-hint class="error" *ngIf="!currentResource"
                    >You must select a Resource</mat-hint
                  >
                  <mat-hint *ngIf="currentResource">
                    {{ currentResource.description }}
                  </mat-hint>
                </mat-form-field>
              </div>
            </div>
            <div class="col-12 col-md-3" #headerTop *ngIf="documentType">
              <div class="type-header">
                <mat-form-field appearance="outline">
                  <mat-label>Version</mat-label>
                  <input
                    type="text"
                    placeholder="Select Version"
                    matInput
                    name="versionCtrl"
                    [formControl]="versionCtrl"
                    [matAutocomplete]="autoVersion"
                    (keyup)="changedVersion()"
                  />
                  <mat-autocomplete
                    #autoVersion="matAutocomplete"
                    #versionAutocomplete
                    [displayWith]="displayVersion"
                    (optionSelected)="selectedVersion($event)"
                  >
                    <mat-option
                      *ngFor="let version of filteredVersions"
                      [value]="version"
                      [ngClass]="getStatus()?.cssClass"
                      class="mat-option-baseline"
                    >
                      <span>
                        {{ version.serialNo }}
                        <span class="d-xl-inline d-none legend">
                          <span class="small float-right">
                            {{ getStatus()?.name }}
                          </span>
                        </span>
                      </span>
                    </mat-option>
                  </mat-autocomplete>
                  <mat-hint>
                    <span [ngClass]="getStatus()?.cssClass">
                      {{ getStatus()?.description }}
                    </span>
                  </mat-hint>
                </mat-form-field>
              </div>
            </div>
            <div class="col-12 col-md-3 small pt-3 pr-0 names-container">
              <div
                class="float-right nowrap lineh-2"
                *ngIf="currentVersion?.updatedBy"
              >
                Updated by: <b>{{ currentVersion?.updatedByName }}</b
                ><span *ngIf="currentVersion?.updatedOn"
                  >&nbsp;on:
                  <span class="date">{{
                    currentVersion?.updatedOn | date
                  }}</span></span
                >
              </div>
              <div
                class="float-right nowrap lineh-2"
                *ngIf="currentVersion?.approvedBy"
              >
                Approved by:
                <b>{{
                  currentVersion?.approvedByName ??
                    currentVersion?.approvedBy?.name
                }}</b
                >&nbsp;on:
                <span class="date">{{
                  currentVersion?.approvedOn | date
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section for Preparers -->
      <mat-nav-list class="side-actions" *ngIf="!expandMap && !expandLog">
        <!-- Create -->
        <mat-list-item
          (mouseenter)="checkCreateEnabled()"
          *ngIf="isPreparer || hasPreparerPriv()"
          (click)="create()"
          class="parent"
          [disabled]="!createEnabled"
          [matTooltip]="message.text"
          [matTooltipClass]="message.cssClass"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>

        <!-- Duplicate -->
        <mat-list-item
          (click)="duplicate()"
          class="parent"
          *ngIf="currentVersion && (isPreparer || hasPreparerPriv())"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Duplicate</span
          >
          <mat-icon matListItemIcon class="blue">file_copy</mat-icon>
        </mat-list-item>

        <!-- Rework -->

        <mat-list-item
          (click)="rework()"
          class="parent"
          *ngIf="showRework() && (isPreparer || isApprover)"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing">Rework</span>
          <mat-icon matListItemIcon class="red">edit</mat-icon>
        </mat-list-item>

        <!-- Submit to Review -->

        <mat-list-item
          (click)="submitToReview()"
          class="parent"
          *ngIf="
            showSubmitToReview() && isPreparer && procedurePreparerSignature
          "
          [disabled]="reviewDisabled()"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Submit to Review</span
          >
          <mat-icon matListItemIcon class="green">send</mat-icon>
        </mat-list-item>

        <!-- Submit to Approve -->
        <mat-list-item
          (click)="submitToApprove()"
          class="parent"
          *ngIf="
            currentVersion?.status == checklistTemplateStatusEnum.Draft &&
            !service.procedure &&
            isPreparer
          "
          [disabled]="(errorMessages?.length ?? 0) > 0"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Submit to Approval</span
          >
          <mat-icon matListItemIcon class="blue">send</mat-icon>
        </mat-list-item>

        <!-- Delete -->

        <mat-list-item
          (click)="delete()"
          class="parent"
          *ngIf="
            (currentVersion?.status == checklistTemplateStatusEnum.Draft ||
              currentVersion?.status ==
                checklistTemplateStatusEnum.CorrectionsInProgress) &&
            (!procedurePreparerSignature?.signedOn ||
              !procedurePreparerSignature) &&
            isPreparer
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing">Delete</span>
          <mat-icon matListItemIcon class="red">delete</mat-icon>
        </mat-list-item>
      </mat-nav-list>

      <!-- End Region for Preparer -->
      <div
        class="side-flex-panel d-flex justify-content-start flex-column border-top"
        *ngIf="!expandLog"
      >
        <mat-nav-list *ngIf="currentVersion">
          <mat-list-item class="full-height pr-0 side-panel-list-item">
            <span *ngIf="isExpanded || isShowing"
              >Template Map
              <span
                class="float-right material-symbols-outlined gray"
                *ngIf="!expandMap && !expandLog"
                (click)="expandMap = true"
              >
                expand_content
              </span>

              <span
                class="float-right material-symbols-outlined gray"
                *ngIf="expandMap"
                (click)="expandMap = false"
              >
                collapse_content
              </span>
            </span>
            <mat-icon
              matListItemIcon
              class="green align-self-start"
              matTooltip="Template Map"
              >account_tree</mat-icon
            >
            <div
              class="pr-1 side-panel-scroll"
              [ngClass]="{ 'map-container': !expandMap && !expandLog }"
            >
              <checklist-builder-map
                [ngClass]="{ invisible: !isExpanded && !isShowing }"
                [checklistTemplate]="currentVersion"
                [showDeleted]="showDeleted"
                (changed)="rowSelected($event)"
              ></checklist-builder-map>
            </div>
          </mat-list-item>
        </mat-nav-list>
        <mat-nav-list
          class="side-actions"
          *ngIf="
            currentVersion &&
            checklistBuilderMap?.hasDeletedItems &&
            (currentVersion.status == checklistTemplateStatusEnum.Draft ||
              currentVersion.status ==
                checklistTemplateStatusEnum.CorrectionsInProgress)
          "
        >
          <mat-list-item *ngIf="!showDeleted" (click)="setShowDeleted(true)">
            <span class="full-width" *ngIf="isExpanded || isShowing"
              >Show Deleted items</span
            >
            <div matListItemIcon class="icon-wrapper">
              <mat-icon class="icon-main red">delete</mat-icon>
              <mat-icon class="icon-overlay-show">visibility</mat-icon>
            </div>
          </mat-list-item>
          <mat-list-item *ngIf="showDeleted" (click)="setShowDeleted(false)">
            <span class="full-width" *ngIf="isExpanded || isShowing"
              >Hide Deleted items</span
            >
            <div matListItemIcon class="icon-wrapper">
              <mat-icon class="icon-main red">delete</mat-icon>
              <mat-icon class="icon-overlay-hide">visibility_off</mat-icon>
            </div>
          </mat-list-item>
        </mat-nav-list>
      </div>

      <!-- Region for Reviewers -->

      <mat-nav-list
        *ngIf="isReviewer && !expandMap && !expandLog && hasAnyReviewActions"
        class="side-actions border-top"
      >
        <!-- Start Reviewing -->
        <mat-list-item
          *ngIf="canStartReviewing"
          (click)="review()"
          class="parent"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing">Review</span>
          <mat-icon matListItemIcon class="orange">visibility</mat-icon>
        </mat-list-item>

        <!-- Finish Reviewing -->
        <mat-list-item
          *ngIf="canFinishReviewing"
          (click)="reviewed()"
          class="parent"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >End Review</span
          >
          <mat-icon matListItemIcon class="purple">send</mat-icon>
        </mat-list-item>
      </mat-nav-list>

      <!-- End Region for Reviewers -->

      <!-- Region for Approvers -->

      <mat-nav-list
        *ngIf="isApprover && !expandMap && !expandLog && hasAnyApproveActions"
        class="side-actions border-top"
      >
        <!-- Approve -->
        <mat-list-item
          *ngIf="canApproveTemplate"
          (click)="approve()"
          class="parent"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Approve Template</span
          >
          <mat-icon matListItemIcon class="green">check_circle</mat-icon>
        </mat-list-item>

        <!-- End Suggestions -->
        <mat-list-item
          *ngIf="canEndSuggesting"
          (click)="approve()"
          class="parent"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >End Suggesting</span
          >
          <mat-icon matListItemIcon class="pink">mark_chat_read</mat-icon>
        </mat-list-item>

        <!-- Unapprove -->
        <mat-list-item
          *ngIf="canUnapproveTemplate"
          (click)="unapprove()"
          class="parent"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Unapprove Template</span
          >
          <mat-icon matListItemIcon class="orange">unpublished</mat-icon>
        </mat-list-item>

        <!-- Reject -->
        <mat-list-item *ngIf="canReject" (click)="reject()" class="parent">
          <span class="full-width" *ngIf="isExpanded || isShowing">Reject</span>
          <mat-icon matListItemIcon class="red">unpublished</mat-icon>
        </mat-list-item>

        <!-- Suggest -->
        <mat-list-item
          *ngIf="canSuggestChanges"
          (click)="suggest()"
          class="parent"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Suggest Changes</span
          >
          <mat-icon matListItemIcon class="purple">quickreply</mat-icon>
        </mat-list-item>
      </mat-nav-list>

      <!-- End Region for Approvers -->
      <mat-nav-list
        #archive
        *ngIf="
          (isSA() || isRADArchiver()) &&
          currentVersion?.status == checklistTemplateStatusEnum.Active &&
          !expandMap &&
          !expandLog
        "
        class="side-actions border-top"
      >
        <mat-list-item (click)="setArchived()" class="parent">
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Archive</span
          >
          <mat-icon matListItemIcon class="gray">archive</mat-icon>
        </mat-list-item>
      </mat-nav-list>

      <div
        class="side-flex-panel d-flex justify-content-start flex-column border-top"
        *ngIf="!expandMap"
      >
        <mat-nav-list #log *ngIf="currentVersion?.serialNo">
          <mat-list-item class="full-height pr-0 side-panel-list-item">
            <span
              *ngIf="isExpanded || isShowing"
              class="d-flex justify-content-between"
              ><span class="d-flex"
                >Logs
                <span
                  class="ml-1 material-symbols-outlined gray"
                  *ngIf="logs.sortDown"
                  (click)="logs.sortDown = false; logs.sort()"
                  >clock_arrow_down</span
                ><span
                  class="ml-1 material-symbols-outlined gray"
                  (click)="logs.sortDown = true; logs.sort()"
                  *ngIf="!logs.sortDown"
                  >clock_arrow_up</span
                ></span
              >
              <span
                class="material-symbols-outlined gray"
                *ngIf="!expandLog"
                (click)="expandLog = true"
              >
                expand_content
              </span>

              <span
                class="material-symbols-outlined gray"
                *ngIf="expandLog"
                (click)="expandLog = false"
              >
                collapse_content
              </span>
            </span>
            <mat-icon
              matListItemIcon
              class="orange align-self-start"
              matTooltip="Template Map"
              >history</mat-icon
            >
            <div
              class="pr-1 side-panel-scroll"
              [ngClass]="{ 'map-container': !expandMap && !expandLog }"
            >
              <checklist-builder-log
                #logs
                [serialNo]="currentVersion!.serialNo"
              ></checklist-builder-log>
            </div>
          </mat-list-item>
        </mat-nav-list>
      </div>

      <mat-nav-list
        #filter
        *ngIf="!currentVersion && !expandMap && !expandLog"
        class="side-flex-panel pb-3 border-top"
      >
        <mat-list-item class="parent" style="padding-top: 12px">
          <span *ngIf="isExpanded || isShowing">Filter</span>
          <mat-icon matListItemIcon class="blue">filter_alt</mat-icon>
        </mat-list-item>
        <mat-selection-list
          #statusx
          class="pl-3"
          *ngIf="isExpanded || isShowing"
        >
          <mat-list-option
            class="list-option"
            *ngFor="let status of filteredStatuses()"
            [selected]="status.selected"
            [value]="status.statusEnum"
            (click)="filterChanged(status)"
          >
            <mat-icon matListItemIcon [ngClass]="status.cssClass">{{
              status.icon
            }}</mat-icon>
            {{ status.name }}
          </mat-list-option>
        </mat-selection-list>
      </mat-nav-list>

      <mat-nav-list
        class="side-bottom-actions pb-3 d-flex flex-column justify-content-end border-top"
        *ngIf="!expandMap && !expandLog"
      >
        <mat-list-item
          (click)="placeholders()"
          class="parent"
          *ngIf="currentVersion"
        >
          <span class="pl-icon">{{ "{" }}{{ "}" }}</span>
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Placeholders</span
          >
        </mat-list-item>
        <mat-list-item
          (click)="settings()"
          class="parent"
          *ngIf="isSA() && documentType"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Settings</span
          >
          <mat-icon matListItemIcon class="gray">settings</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <checklist-builder-review-summary
        #reviewSummary
        *ngIf="currentSchedule && currentVersion && currentTemplateType"
        [currentVersion]="currentVersion"
        [templateType]="currentTemplateType"
        (requestRefresh)="setProcedure()"
      >
      </checklist-builder-review-summary>
      <checklist-builder-reject
        [errorMessages]="errorMessages ?? []"
        *ngIf="errorMessages?.length"
      >
      </checklist-builder-reject>

      <div
        id="scrollableContainer"
        #scrollableContainer
        class="sidenav-content p-2"
        scrollDetector
        (scroll)="onScroll()"
      >
        <checklist-builder-sections
          *ngIf="currentVersion && sections"
          [sections]="sections"
          [showDeleted]="showDeleted"
          [currentVersion]="currentVersion"
          [wfTableID]="currentVersion.wfTableID"
          class="full-width"
          [disabled]="disableSections()"
          (errorsDetected)="errorsDetected($event)"
        ></checklist-builder-sections>

        <checklist-builder-list
          *ngIf="!currentVersion"
          [checklistTemplates]="filteredChecklistTemplates"
          (rowSelected)="rowSelectedFromList($event)"
        ></checklist-builder-list>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- "loading">
    <!-- Copyright 2017 Google Inc. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->
  <!-- </overlay-loading> -->
</div>
